<template>
  <Modal
    id="emailTaken"
    buttonName="CLOSE"
    ref="modalActivate"
    title="Activate your account"
    @button="closeModal()"
    :materialButton="true"
  >
    <footer class="h5 font-weight-normal register-response">
      <h4>Account has not been activated</h4>
      <span
        ><br /><br />Before signing in, validate your account using the
        validation email sent to you.</span
      >
      <br />
      <span v-if="!emailResend">
        <strong>Didn't receive the email?</strong>
        Please check your spam folder, or click
        <a class="resend-email-link" @click.prevent="resendActivationEmail"
          >resend</a
        >
        and we'll send it again.
      </span>
      <span
        v-html="emailResend"
        class="the-email-resend"
        v-if="emailResend"
      ></span>
    </footer>
  </Modal>
</template>

<script>
import Modal from "@/components/atoms/Modal.vue";
import UserHelperVue from "@/mixins/UserHelper.vue";
export default {
  name: "ModalActivation",
  props: ["activationResendObj"],
  mixins: [UserHelperVue],
  components: {
    Modal,
  },
  data() {
    return {
      emailResend: null,
    };
  },
  methods: {
    closeModal() {
      this.$refs.modalActivate.closeModal();
      this.emailResend = null;
    },
    resendActivationEmail() {
      this.resendActivation({
        email: this.activationResendObj.email,
        token: this.activationResendObj.token,
      });
      this.emailResend = "<br/><strong>Email successfully resent<strong/>";
    },
  },
};
</script>

<style lang="scss" scoped>
.the-email-resend {
  color: $primary;
}
.resend-email-link {
  text-decoration: none !important;
  cursor: pointer;
  color: $primary;
}
.center-content-back {
  height: 20rem;
  margin-top: -20px;
}
</style>
